@import 'src/client/view/style/constants.scss';

.tableWrap {
  table {
    margin: 0 auto;
    max-width: 100vh;
    width: 100%;
  }
}
